import { EastOutlined, ErrorOutlineOutlined } from "@mui/icons-material";
import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import { colors } from "../../theme/theme";

const EmailConfirmationAlert = () => {
  return (
    <Box
      sx={{
        backgroundColor: "rgba(255,255,255,0.14)",
        borderRadius: "14px",
        py: 1.5,
        px: 2,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Stack direction="row" spacing={2} alignItems="center">
        <ErrorOutlineOutlined sx={{ color: "#fff" }} />
        <Typography
          sx={{
            fontFamily: "Mulish-Regular",
            fontSize: "14px",
            color: "#fff",
          }}
        >
          Before you interact with other, you’ll need to confirm your email
          address.
        </Typography>
      </Stack>
      <Stack
        direction="row"
        spacing={1}
        sx={{
          alignItems: "center",
          cursor: "pointer",
        }}
      >
        <Typography
          sx={{
            color: colors.secondary,
            fontFamily: "Mulish-Regular",
            fontSize: "12px",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          Send me confirmation email
        </Typography>
        <EastOutlined sx={{ color: colors.secondary, fontSize: "20px" }} />
      </Stack>
    </Box>
  );
};

export default EmailConfirmationAlert;
